import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  menu: any = [
    {
      title: "Inicio",
      icon: "mdi mdi-home-outline",
      url: "/home",
      class: "waves-effect waves-dark",
      routerLinkActive: "active",
    },
    {
      title: "Items",
      icon: "mdi mdi-library-plus",
      url: "#/",
      class: "has-arrow waves-effect waves-dark",
      routerLinkActive: "",
      submenu: [
        {
          title: "Inicio (Home)",
          url: "#/",
          class: "show-sidebar has-arrow waves-effect waves-dark",
          routerLinkActive: "",
          homeSubmenu: [
            {
              title: "Eventos",
              url: "/items/event",
              class: "show-sidebar waves-effect waves-dark",
              routerLinkActive: "active",
            },
            {
              title: "Recomendados",
              url: "/items/recommended",
              class: "show-sidebar waves-effect waves-dark",
              routerLinkActive: "active",
            },
            {
              title: "Servicios",
              url: "/items/services",
              class: "show-sidebar waves-effect waves-dark",
              routerLinkActive: "active",
            },
            // {
            //   title: "Casos de Éxito",
            //   url: "/items/success",
            //   class: "show-sidebar waves-effect waves-dark",
            //   routerLinkActive: "active",
            // },
          ],
        },
        {
          title: "Mentorías",
          url: "/items/academy",
          class: "show-sidebar waves-effect waves-dark",
          routerLinkActive: "active",
        },
        {
          title: "Curso 0 a 100",
          url: "/items/trading",
          class: "show-sidebar waves-effect waves-dark",
          routerLinkActive: "active",
        },
        {
          title: "Paso a Paso",
          url: "/items/pasoapaso",
          class: "show-sidebar waves-effect waves-dark",
          routerLinkActive: "active",
        },
      ],
    },
    {
      title: "Notificaciones Push",
      icon: "mdi mdi-message-alert",
      url: "/push-notifications",
      class: "waves-effect waves-dark",
      routerLinkActive: "active",
    },
    {
      title: "Notificaciones Semanales",
      icon: "mdi mdi-calendar-text",
      url: "/calendar",
      class: "waves-effect waves-dark",
      routerLinkActive: "active",
    },
    {
      title: "Agendas",
      icon: "mdi mdi-calendar-clock",
      url: "/schedule",
      class: "waves-effect waves-dark",
      routerLinkActive: "active",
    },
    {
      title: "Control de Usuarios",
      icon: "mdi mdi-account-multiple",
      url: "/users",
      class: "waves-effect waves-dark",
      routerLinkActive: "active",
    },
  ];

  signalsMenu: any = [
    {
      title: "Señales",
      icon: "mdi mdi-library-plus",
      url: "#/",
      class: "has-arrow waves-effect waves-dark",
      routerLinkActive: "",
      submenu: [
        {
          title: "Índices Sintéticos",
          url: "/items/signals",
          class: "waves-effect waves-dark",
          routerLinkActive: "active",
        },
        {
          title: "Forex / Futuros",
          url: "/items/forex",
          routerLinkActive: "active",
          class: "waves-effect waves-dark",
        },
        // {
        //   title: "OneBet",
        //   url: "/items/onebet",
        //   routerLinkActive: "active",
        //   class: "waves-effect waves-dark",
        // },
      ],
    },
  ];
}
